import './create-request-by-type-modal.scss';

import { Modal } from 'antd';
import classNames from 'classnames';
import { useState } from 'react';

import { Button } from '@/components/Shared/ui';

type TProps = {
  isOpen: boolean;
  onClose: () => void;
  onCreateForIeClick: () => void;
  onCreateForLlpClick: () => void;
};

type TRequestType = 'IE' | 'LLP';

const REQUEST_TYPE_LABELS: Record<TRequestType, string | undefined> = {
  IE: 'ИП',
  LLP: 'ТОО'
};

const CreateRequestByTypeModal: React.FC<TProps> = ({
  isOpen,
  onClose,
  onCreateForIeClick,
  onCreateForLlpClick
}) => {
  const [selectedType, setSelectedType] = useState<TRequestType | ''>('');

  const handleClose = () => {
    setSelectedType('');
    onClose();
  };

  const handleNext = () => {
    if (!selectedType) return;

    if (selectedType === 'IE') {
      onCreateForIeClick();
    } else if (selectedType === 'LLP') {
      onCreateForLlpClick();
    }
    handleClose();
  };

  return (
    <Modal
      centered
      className="create-request-by-type-modal"
      title="Создание заявки"
      open={isOpen}
      onCancel={handleClose}
      mask={{ closable: true }}
      footer={null}
    >
      <p className="create-request-by-type-modal__subtitle">
        Выберите тип заявки
      </p>

      <div className="create-request-by-type-modal__buttons">
        <TypeButton
          type="IE"
          selectedType={selectedType}
          setSelectedType={setSelectedType}
        />
        <TypeButton
          type="LLP"
          selectedType={selectedType}
          setSelectedType={setSelectedType}
        />
      </div>

      <div className="create-request-by-type-modal__actions">
        <Button type="button" onClick={handleClose}>
          Отмена
        </Button>
        <Button
          onClick={handleNext}
          disabled={!selectedType}
          type="button"
          variant="filled-red"
        >
          Далее
        </Button>
      </div>
    </Modal>
  );
};

const TypeButton: React.FC<{
  type: TRequestType;
  selectedType: TRequestType | '';
  setSelectedType: (type: TRequestType) => void;
}> = ({ type, selectedType, setSelectedType }) => {
  return (
    <button
      className={classNames('create-request-by-type-modal__type-button', {
        'create-request-by-type-modal__type-button--selected':
          type === selectedType
      })}
      onClick={() => setSelectedType(type)}
    >
      {REQUEST_TYPE_LABELS[type] || type}
    </button>
  );
};

export default CreateRequestByTypeModal;
